module.exports = __webpack_public_path__ + "static/hero-8ef38efc83a15c07a5c199a9d8b93734.png";